import { css } from '@emotion/react';
import { motion } from 'framer-motion';
import * as React from 'react';

export const BlurCover: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: 'easeOut', duration: 0.2 }}
      css={styles.overlay}
    />
  );
};

const styles = {
  overlay: css({
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 25, // z-index should be higher than logo deck items
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
  }),
};
